module.exports = __webpack_public_path__ + "static/img/down_qrcode.742b1edc.png";